import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  connect() {
    this.element.remove()
    if (this.data.get("type") === "notice") {
      iziToast.success({message: this.data.get("message"), title: "Success", position: "topRight", timeout: 5000})
    } else if (this.data.get("type") === "alert") {
      iziToast.error({message: this.data.get("message"), title: "Error", position: "topRight", timeout: 5000})
    } else {
      iziToast.info({message: this.data.get("message"), title: "Info", position: "topRight", timeout: 5000})
    }
  }

}
